// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as App_Table$DvmAdminFrontendFr from "../../../../common/components/table/App_Table.bs.js";
import * as Utils_Api$DvmAdminFrontendFr from "../../../../common/utils/Utils_Api.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../../intl/Intl_Utils.bs.js";
import * as App_Table_Head$DvmAdminFrontendFr from "../../../../common/components/table/App_Table_Head.bs.js";
import * as App_Table_Types$DvmAdminFrontendFr from "../../../../common/components/table/App_Table_Types.bs.js";
import * as Messages_Common$DvmAdminFrontendFr from "../../../../intl/messages/Messages_Common.bs.js";
import * as Messages_Quotas$DvmAdminFrontendFr from "../../../../intl/messages/quotas/Messages_Quotas.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../common/types/App_Types_Result.bs.js";
import * as Quota_Admin_Types$DvmAdminFrontendFr from "./Quota_Admin_Types.bs.js";
import * as Quota_Admin_Router$DvmAdminFrontendFr from "./Quota_Admin_Router.bs.js";
import * as App_Table_Pagination$DvmAdminFrontendFr from "../../../../common/components/table/App_Table_Pagination.bs.js";
import * as App_Table_Export_Menu$DvmAdminFrontendFr from "../../../../common/components/table/App_Table_Export_Menu.bs.js";
import * as Messages_Quotas_Detail$DvmAdminFrontendFr from "../../../../intl/messages/quotas/Messages_Quotas_Detail.bs.js";

var headersConfiguration_0 = App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Quota_Admin_Types$DvmAdminFrontendFr.FilterFields.dr, /* Asc */0, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.territory);

var headersConfiguration_1 = {
  hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Quota_Admin_Types$DvmAdminFrontendFr.FilterFields.contractId, undefined, undefined, undefined, undefined, undefined, Messages_Quotas$DvmAdminFrontendFr.contractId),
  tl: {
    hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Quota_Admin_Types$DvmAdminFrontendFr.FilterFields.vehicleType, undefined, undefined, undefined, undefined, undefined, Messages_Quotas_Detail$DvmAdminFrontendFr.vehicleType),
    tl: {
      hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Quota_Admin_Types$DvmAdminFrontendFr.FilterFields.volume, undefined, undefined, undefined, undefined, undefined, Messages_Quotas_Detail$DvmAdminFrontendFr.volume),
      tl: {
        hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Quota_Admin_Types$DvmAdminFrontendFr.FilterFields.startDate, /* Desc */1, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.startDate),
        tl: {
          hd: App_Table_Head$DvmAdminFrontendFr.makeHeaderCell(Quota_Admin_Types$DvmAdminFrontendFr.FilterFields.endDate, undefined, undefined, undefined, undefined, undefined, Messages_Common$DvmAdminFrontendFr.endDate),
          tl: /* [] */0
        }
      }
    }
  }
};

var headersConfiguration = {
  hd: headersConfiguration_0,
  tl: headersConfiguration_1
};

function Quota_Admin_Table(Props) {
  var tablePage = Props.tablePage;
  var fetchRequest = Props.fetchRequest;
  var fetchData = Props.fetchData;
  var intl = ReactIntl.useIntl();
  var convertTable = function (table) {
    return App_Types_Result$DvmAdminFrontendFr.map(table, (function (param) {
                  return {
                          content: Belt_List.map(param.content, (function (quota) {
                                  return App_Table_Types$DvmAdminFrontendFr.makeRow((function (param) {
                                                Quota_Admin_Router$DvmAdminFrontendFr.routeToDetailEditUpdate(quota, undefined);
                                              }), undefined, undefined, Belt_List.mapWithIndex({
                                                  hd: quota.dr,
                                                  tl: {
                                                    hd: quota.contractId,
                                                    tl: {
                                                      hd: quota.vehicleType,
                                                      tl: {
                                                        hd: Belt_Option.mapWithDefault(quota.volume, "", (function (prim) {
                                                                return String(prim);
                                                              })),
                                                        tl: {
                                                          hd: Intl_Utils$DvmAdminFrontendFr.formatDate(intl, quota.startDate),
                                                          tl: {
                                                            hd: Belt_Option.mapWithDefault(quota.endDate, "", (function (param) {
                                                                    return Intl_Utils$DvmAdminFrontendFr.formatDate(intl, param);
                                                                  })),
                                                            tl: /* [] */0
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }, (function (index, content) {
                                                    return App_Table$DvmAdminFrontendFr.makeCell(Belt_Option.map(Belt_List.get(headersConfiguration, index), (function (param) {
                                                                      return param.align;
                                                                    })), undefined, undefined, content);
                                                  })));
                                })),
                          currentPage: fetchRequest.page,
                          totalElements: param.total
                        };
                }));
  };
  var handleSorting = function (headers) {
    Curry._2(fetchData, undefined, {
          page: fetchRequest.page,
          rowsPerPage: fetchRequest.rowsPerPage,
          headers: headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var handleChangePage = function (page) {
    Curry._2(fetchData, undefined, {
          page: page,
          rowsPerPage: fetchRequest.rowsPerPage,
          headers: fetchRequest.headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  var handleRowsPerPageChange = function (rowsPerPage) {
    Curry._2(fetchData, undefined, {
          page: fetchRequest.page,
          rowsPerPage: rowsPerPage,
          headers: fetchRequest.headers,
          filterQueryParams: fetchRequest.filterQueryParams,
          additionalQueryParams: fetchRequest.additionalQueryParams
        });
  };
  return React.createElement(React.Fragment, undefined, React.createElement(App_Table$DvmAdminFrontendFr.make, {
                  headers: fetchRequest.headers,
                  handleSorting: handleSorting,
                  tablePage: convertTable(tablePage),
                  paginator: App_Table_Pagination$DvmAdminFrontendFr.makePaginator(undefined, undefined, handleChangePage, handleRowsPerPageChange, undefined),
                  exportMenu: React.createElement(App_Table_Export_Menu$DvmAdminFrontendFr.make, {
                        query: Utils_Api$DvmAdminFrontendFr.createQueryParams(undefined, {
                              page: 0,
                              rowsPerPage: 150000,
                              headers: fetchRequest.headers,
                              filterQueryParams: fetchRequest.filterQueryParams,
                              additionalQueryParams: fetchRequest.additionalQueryParams
                            }),
                        endpoint: "quotas/page"
                      })
                }));
}

var Router;

var make = Quota_Admin_Table;

export {
  Router ,
  headersConfiguration ,
  make ,
}
/* headersConfiguration Not a pure module */
